import React from "react";

const FirstPlace = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="27.218"
    height="35.485"
    viewBox="0 0 27.218 35.485">
    <g id="Group_9162" transform="translate(-208.782 -456.532)">
      <path
        id="Path_15239"
        d="M2298.555 187.392l-9.742-4.16-9.741 4.16V162.7h19.483z"
        className="cls-1-mobile"
        transform="translate(-2066.482 304.625)"
      />
      <g id="Group_9161" transform="translate(-2662.098 -48.201)">
        <circle
          id="Ellipse_1689"
          cx="13.609"
          cy="13.609"
          r="13.609"
          fill="#f6aa30"
          transform="translate(2870.88 504.732)"
        />
        <circle
          id="Ellipse_1690"
          cx="10.465"
          cy="10.465"
          r="10.465"
          className="cls-1-mobile"
          transform="translate(2874.024 507.876)"
        />
        <text
          id="_1"
          fill="#f6aa30"
          fontFamily="Roboto-Black, Roboto"
          fontSize="14px"
          fontWeight="800"
          transform="translate(2880.979 523.029)">
          <tspan x="0" y="0">
            1
          </tspan>
        </text>
      </g>
    </g>
  </svg>
);

export default FirstPlace;
